<div class="grid  align-items-center py-3">
  <div class="notification-controls-wrapper">
    <!-- Mark All as Read Button -->
    <div class="mark-all-container">
      <button 
        pButton 
        type="button" 
        class="mark-all-button" 
        label="Mark all as read" 
        size="small" 
        (click)="markAllAsRead()">
      </button>
    </div>
    
    <!-- Toggle Section -->
    <div class="toggle-container">
      <p-inputSwitch 
        id="onlyUnread" 
        [(ngModel)]="onlyShowUnread" 
        (onChange)="applyFilters()">
      </p-inputSwitch>
      <label for="onlyUnread" class="toggle-label select-none mb-0">
        <span class="toggle-text-full">Only show unread</span>
        <span class="toggle-text-short">Unread only</span>
      </label>
    </div>
  </div>



  <div class="notification-list custom-scroll">
    <ng-container *ngIf="notifications.length > 0; else noNotifications">
      <div *ngFor="let notif of notifications" class="notification-card border-b pb-3 mb-1"
        [ngClass]="{'cursor-pointer': notif?.read === false}"
        (click)="markAsRead(notif)">
        <div class="flex gap-3">
          <div class="avatar">
            <!-- If imageUrl is present and non-empty -->
            <img *ngIf="notif?.imageUrl" [src]="notif.imageUrl" alt="Avatar" class="avatar-img" />

            <!-- Else show initials -->
            <span *ngIf="!notif?.imageUrl">
              {{ getInitials(notif?.title || '') }}
            </span>
          </div>
          <div class="content w-full">
            <div class="flex justify-between items-start">
              <p class="message">{{ notif?.message }}</p>
              <span *ngIf="!notif?.read" class="dot"></span>
            </div>
            <div class="flex align-items-center justify-content-start mt-2 text-xs text-gray-500 gap-2">
              <span class="flex align-items-center gap-2">
                {{ getTimeAgo(convertTimestampToDate(notif?.createdAt)) }}
                <span class="tag" [ngClass]="getTagClass(notif?.title || '')">
                  {{ notif?.title }}
                </span>
              </span>
              <span class="flex-1"></span>
              <i
                      class="pi pi-arrow-right text-blue-600 hover:text-blue-700 cursor-pointer"
                      
                      (click)="redirectToPage(notif.actionUrl || '')"
                    ></i>
            </div>
             <!-- Redirection Icon -->
                    


          </div>
        </div>
      </div>
    </ng-container>

    <!-- Empty State -->
    <ng-template #noNotifications>
      <div class="flex flex-column align-items-center justify-content-center text-gray-500 text-sm p-4"
        style="height: 200px;">
        <i class="pi pi-bell-off text-4xl mb-3"></i>
        <span>No Notifications Received</span>
      </div>
    </ng-template>
  </div>
</div>